namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_notebook2_adds, {

		position: 'absolute',
		left: 0,
		top: 0,
		width: 0,
		height: 0,
		overflow: 'visible',
		pointerEvents: 'none',
		zIndex: 1000000,

	} )
	
}
